import request from '@/router/axios';

const urlPrefix = process.env.VUE_APP_LOCAL_DEVELOPMENT == 'false' ? '/wage' : '/wage'
//查看工資審批
export function approvalDetails(obj) {
  return request({
    url: urlPrefix + '/salaryApproval/queryListPageQuery/',
    method: 'post',
    data: obj,
  });
}
//提交审批
export function submitApproval(obj) {
  return request({
    url: urlPrefix + '/salaryApproval/submitApproval/',
    method: 'post',
    data: obj,
  });
}
